/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseShopTheLookCustomFragment, ShopTheLookCustomFragment, FullShopTheLookCustomFragment} from '@amblique/contentful/app/contentful/fragments/shop-the-look-custom';

/**
 * Get a single ShopTheLookCustom by ID (base - scalars only)
 */
export const getBaseShopTheLookCustomById = gql`
  ${BaseShopTheLookCustomFragment}

  query GetBaseShopTheLookCustomById($id: String!, $locale: String!, $preview: Boolean) {
    shopTheLookCustom(id: $id, locale: $locale, preview: $preview) {
      ...BaseShopTheLookCustomFragment
    }
  }
`;

/**
 * Get a single ShopTheLookCustom by ID (standard - 1 level deep)
 */
export const getShopTheLookCustomById = gql`
  ${ShopTheLookCustomFragment}

  query GetShopTheLookCustomById($id: String!, $locale: String!, $preview: Boolean) {
    shopTheLookCustom(id: $id, locale: $locale, preview: $preview) {
      ...ShopTheLookCustomFragment
    }
  }
`;

/**
 * Get a single ShopTheLookCustom by ID (full - 2 levels deep)
 */
export const getFullShopTheLookCustomById = gql`
  ${FullShopTheLookCustomFragment}

  query GetFullShopTheLookCustomById($id: String!, $locale: String!, $preview: Boolean) {
    shopTheLookCustom(id: $id, locale: $locale, preview: $preview) {
      ...FullShopTheLookCustomFragment
    }
  }
`;

/**
 * Get all ShopTheLookCustom entries with pagination (base - scalars only)
 */
export const getBaseShopTheLookCustoms = gql`
  ${BaseShopTheLookCustomFragment}

  query GetBaseShopTheLookCustoms(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [ShopTheLookCustomOrder]
    $where: ShopTheLookCustomFilter
    $preview: Boolean
  ) {
    shopTheLookCustomCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseShopTheLookCustomFragment
      }
    }
  }
`;

/**
 * Get all ShopTheLookCustom entries with pagination (standard - 1 level deep)
 */
export const getShopTheLookCustoms = gql`
  ${ShopTheLookCustomFragment}

  query GetShopTheLookCustoms(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [ShopTheLookCustomOrder]
    $where: ShopTheLookCustomFilter
    $preview: Boolean
  ) {
    shopTheLookCustomCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...ShopTheLookCustomFragment
      }
    }
  }
`;

/**
 * Get all ShopTheLookCustom entries with pagination (full - 2 levels deep)
 */
export const getFullShopTheLookCustoms = gql`
  ${FullShopTheLookCustomFragment}

  query GetFullShopTheLookCustoms(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [ShopTheLookCustomOrder]
    $where: ShopTheLookCustomFilter
    $preview: Boolean
  ) {
    shopTheLookCustomCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullShopTheLookCustomFragment
      }
    }
  }
`;
